<template>
  <v-select
    v-model="item"
    :items="items"    
    :loading="isLoading"
    :error-messages="error"    
    label="Status de Pedido"    
    item-text="label"
    item-value="raw"
    clearable
    outlined
    dense    
    @input="$emit('input', item)"
  />
</template>

<script>
  import orderService from '@/services/pedidos.service';

  export default {
    name: 'SearchOrderStatusSelect',

    props: {
      value: {
        type: [String, Number],
        default: null
      }
    },

    data: () => ({
      isLoading: false,
      error: null,
      items: [],
      item: null
    }),

    mounted() {
      this.item = this.value;

      this.fetch();
    },

    methods: {
      fetch() {
        this.isLoading = true;
        orderService.listStatus().subscribe((response) => {          
          this.items = response;
          this.isLoading = false;
        }, () => {
          this.error = 'Erro ao carregar os status de pedido';
          this.isLoading = false;
        });
      },      
    }
  };
</script>
